module.exports = __webpack_public_path__ + "static/media/03-eCSR-bk_4x.9ee2ba6c.png";